import { CtProp } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import ContentModule from '@/utils/store'

export const model = {
    id: {
      field: 'id',
      label: 'ID',
      validator: () => true,
      type: 'string',
      default: 'prop-id',
      required: true
    },
    value: {
      field: 'value',
      label: 'Value',
      validator: () => true,
      type: 'string',
      default: null,
      required: true
    },
    name: {
      field: 'name',
      label: 'Name',
      validator: () => true,
      type: 'string',
      default: 'prop-name',
      required: true
    },
    type: {
      field: 'type',
      label: 'Type',
      validator: () => true,
      type: 'string',
      default: 'default',
      required: true
    }
  }

// specify actions etc. for orders using Directr
const state = {}
const getters = {}
const mutations = {}
const actions = {}

export default ContentModule<CtProp>(
  ContentType.Prop, 'Services/Directr',
  model,
  state,
  getters,
  mutations,
  actions)
